import {apiHelper} from '@/util'
import {SHARED} from '@/constants/constants'

/* SERVICE EXPORT FUNCTION NAME */
export const inboxService = {
    getInboxMsg,
    readInboxMsg,
    getInboxMsgContent,
    deleteInboxMsg
}

/* SERVICE URL PATH */
const INBOX = {
    INBOX: 'inbox',
    CONTENT: 'content',
    READ: 'read/message',
    MESSAGE: 'get/message',
    REMOVE: 'remove/message',
    REMOVES: 'remove/messages'
}

function getInboxMsg() {
    return apiHelper().get(`${INBOX.INBOX}/${INBOX.MESSAGE}`)
}

async function getInboxMsgContent(obj) {
    return apiHelper().get(`/${INBOX.INBOX}/${INBOX.MESSAGE}/${INBOX.CONTENT}/${obj.msgId}/${obj.category}`)
}

function readInboxMsg(obj) {
    return apiHelper().post(`/${INBOX.INBOX}/${INBOX.READ}/${obj.msgId}/${obj.categoryId}`)
}

function deleteInboxMsg(payload){
  return apiHelper().post(`/${INBOX.INBOX}/${INBOX.REMOVES}`, payload)
}